/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from 'react';
import 'jspreadsheet-ce/dist/jspreadsheet.css';
import CommonCreationErrorsApp from "./Functionality/CommonCreationErrorsApp";
import routes from "../../Routes/routes";
import CreationErrorsEmployeeApp from "./Functionality/CreationErrorsEmployeeApp";
import {MODELS} from "../../Apis/Models";
import HeadTittle from "../../components/HeadTittle";
import ButtonAction from "../../components/buttons/ButtonAction";
import DivContainerBody from "../../components/DivContainerBody";
import CreationErrorsBody from "./SubComponents/CreationErrorsBody";
import {permissionObj} from "../../Helpers/permission";
import { columnCode } from '../../enums/columnCodeEnum';

const CreationErrorsEmployee = () => {
    const props = CommonCreationErrorsApp({
        moduleId: MODELS.Employee,
        goBack:routes.employee.list,
        validateSpaces:5,
        columns:new Array(14).fill({ type: 'text', width: 78 })
    });
    const {t, DEV, permission, navigate, errorsArray, jRef, totalErrors, selectedErrorIndex, jRefZone, jRefRole, jRefDepartment} = props;
    const {handleConfirm, handleUploadFile} = CreationErrorsEmployeeApp(props);

    if(!DEV && (!permission?.includes(permissionObj.WEB_EMPLOYEE_READ))) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={t('import')} link={routes.employee.list}>
                {totalErrors === 0 ? (
                    <ButtonAction
                        id='btn_cee_import'
                        name='import'
                        className='btn-icon-accent-450'
                        onClick={handleConfirm}
                    />
                ) : (
                    <ButtonAction
                        id='btn_cee_verify'
                        name='verify'
                        className='btn-icon-accent-450'
                        onClick={handleUploadFile}
                    />
                )}
            </HeadTittle>
            <DivContainerBody>
                <CreationErrorsBody
                    mainJRef={{name:t('excel'), jRef:jRef}}
                    jRefList={[{name:t('zone_options'), jRef:jRefZone},
                               {name:t('role_options'), jRef:jRefRole},
                               {name:t('department_options'), jRef:jRefDepartment}]}
                    totalErrors={totalErrors}
                    errorsArray={errorsArray}
                    selectedErrorIndex={selectedErrorIndex}
                    columnCode={columnCode}
                />
            </DivContainerBody>
        </>
    );
};

export default CreationErrorsEmployee;
